interface GeoInfoDma {
  callSignId?: string;
  dmaId?: string;
  [key: string]: unknown;
}

interface GeoInfoResponse {
  dmaId: string;
  country: string;
  region: string;
  city: string;
  clientIp: string;
  dmaGroup: string;
  dmaDaiOptIn: string;
  dmaMarket: string;
  dmas?: GeoInfoDma[];
}

export interface ParsedGeoInfo {
  dmas: GeoInfoDma[];
  stations: (string | undefined)[];
}

export const parseGeoInfo = (response: GeoInfoResponse): ParsedGeoInfo => {
  return {
    dmas: response.dmas,
    stations: (response.dmas || []).map(({ callSignId }) => callSignId),
  };
};
